import React from "react";
import { Helmet } from "react-helmet-async";

interface DynamicHelmetProps {
  title: string;
  description: string;
  url?: string;
}

const DynamicHelmet: React.FC<DynamicHelmetProps> = ({
  title,
  description,
  url,
}) => {
  // Default base URL for the application
  const baseUrl = "https://vax.edsource.org"; // Update this to your actual domain
  const fullUrl = url ? `${baseUrl}${url}` : baseUrl;

  const defaultTitle = "California School Vaccination Database | Edsource";
  const pageTitle = title ? title : defaultTitle;

  const defaultDescription =
    "Use this resource to check vaccination rates at traditional public, public charter, and private schools across California. Search and filter by school type and vaccination rate, or explore the data with a map.";
  const pageDescription = description ? description : defaultDescription;

  return (
    <Helmet>
      {/* Basic meta tags */}
      <title>{pageTitle}</title>
      <meta name="description" content={pageDescription} />
      <meta name="twitter:title" content={pageTitle} />
      <meta name="twitter:description" content={pageDescription} />
      <meta property="og:title" content={pageTitle} />
      <meta property="og:description" content={pageDescription} />
      <meta name="twitter:url" content={fullUrl} />
      <meta property="og:url" content={fullUrl} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:site" content="@edsource" />
      <meta property="og:type" content="article" />
      <meta
        property="og:site_name"
        content="California School Vaccination Database | Edsource"
      />
      <meta property="og:locale" content="en_US" />
      <meta property="article:section" content="News" />
    </Helmet>
  );
};

export default DynamicHelmet;
